<template>
  <div>
    <el-row>
      <el-col :span="8" v-if="competenciaOpen.status">
        <el-card v-loading="isLoading">
          <el-row>
            <el-col class="mb-4" align="center">
              <el-button v-for="processo in processoList"
                         :key="processo.label"
                         type="danger"
                         size="mini"
                         circle
                         @click="execute(processo)">
                {{processo.label}}
              </el-button>
            </el-col>

          </el-row>
          <el-row>
            <el-checkbox-group v-model="gruposSelected">
              <el-col :span="14" v-for="centro in centroCustoList"   :key="centro.id">
                <el-checkbox :label="centro.id">{{centro.nome}}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="16">
        <processo-list v-loading="isLoadingProcessoList" :list="processos" @clickRefresh="load"></processo-list>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {Notification} from 'element-ui'
  import {trataErrors} from "../../domain/utils";
  import ProcessoList from "./ProcessoList";

  export default {
    name: "CompetenciaProcesso",
    components: {ProcessoList},
    props: ['competencia'],
    data() {
      return {
        isLoading: false,
        isLoadingProcessoList: false,
        gruposSelected: [],
        processos: []
      }
    },
    computed: {
      ...mapState(['centroCustoList', 'competenciaOpen', ['processoList']])
    },
    methods: {
      filterMethod(query, item) {
        return item.nome.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      async execute(processo) {
        if (!this.gruposSelected.length) {
          this.$notify.error({
            title: 'Erro',
            message: 'Selecione no minimo 1 Centro de Custo'
          });
          return
        }

        try {
          this.isLoading = true
          const {data} = await axios.post(`${process.env.API_PATH}/processo/executebyname`, {
            processo: processo.nome,
            centroCustoIds: this.gruposSelected
          })
          Notification.success("Processos Enviados para fila de Execução")
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
          this.load()
        }
      },
      async load() {
        try {
          this.isLoadingProcessoList = true
          const {data} = await axios.get(`${process.env.API_PATH}/processo/competencia/${this.competencia.id}`)
          this.processos = [...data]
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoadingProcessoList = false
        }
      }
    },
    created() {
      this.load()
    }
  }
</script>

<style scoped>
  .btn-processo {
    margin-bottom: .5em;
    width: 100%;
  }
  .grupo-active {
    background-color: #9933CC;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/Processo.vue